import React from 'react'

import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';

function bookList() {
  const tabs = [
    { title: 'IBDP BOOK LIST 2026-27', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>IBDP Book List 2026-27</h1>
    </div>
    {/* <div className='print-booklist'>

<Link  to="../pdf/Book-list/Ibdp-booklist/IBDP BOOK LIST (2025-26).pdf"
    target="_blank"
    rel="noopener noreferrer"
> Print Book list </Link>
</div> */}
    <div className='syllubus-data'>
      
   

      <div className='cam-lower-table'>
     
     {/* <h1>table data baki ha abhi</h1> */}
    <table border="1">
  <thead>
    <tr>
      <th>S.NO</th>
      <th class="book-width">NAME OF THE BOOK</th>
      <th>AUTHOR</th>
      <th>PUBLISHER</th>
      <th>ISBN NO.</th>
    </tr>
  </thead>
  <tbody>
    <tr><td>1</td><td>FRENCH AB INITIO (TRICOLOR TOTAL 4)</td><td>HEATHER MASCIE TAYLOR</td><td>OUP</td><td>978-140-850578-6</td></tr>
    <tr><td>2</td><td>FRENCH SL/HL FRENCH-B</td><td></td><td>OUP</td><td>978-0-198422-44-9</td></tr>
    <tr><td>3</td><td>PHYSICS FOR IBDP</td><td>K. A TSOKOS</td><td>CAMBRIDGE</td><td>9781009071888</td></tr>
    <tr><td>4</td><td>CHEMISTRY COURSE COMPANION 2023 EDITION</td><td>GARY HORNER, DAVID TARY</td><td>OXFORD</td><td>978-1-382-016469</td></tr>
    <tr><td>5</td><td>COMPUTER SCIENCE 2025 EDITION</td><td>BILL MACKERLY LINDSEY STEPHENSON</td><td>OXFORD</td><td>978-1-382063920</td></tr>
  
    <tr>
      <td>6</td>
      <td>MATHEMATICS:ANALYSIS AND APPROACHES HL(CORE AND AI)</td>
      <td>MICHAEL HAESE</td>
      <td>HAESE AND HARIS</td>
      <td><p><b>CORE:</b> 978-1-925489-859</p></td>
    </tr>
    <tr><td>7</td><td>MATHEMATICS:AA AND AI CORE SL</td><td>MICHAEL HAESE</td><td>HAESE AND
HARIS</td><td>978-1925489-55-2</td></tr>
    <tr><td>8</td><td>MATHEMATICS:APPLICATIONS AND
INTERPRETATION SL 2</td><td>MICHAEL HAESE</td><td>HAESE AND HARIS</td><td>978-1-925489-57-6</td></tr>
    <tr>
      <td>9</td>
      <td>MATHEMATICS:ANALYSIS AND APPROACHES</td>
      <td>MICHAEL HAESE</td>
      <td>HAESE AND
HARIS</td>
      <td><p><b>CORE:</b> 9781925489590</p></td>
    </tr>
    <tr><td>10</td><td>BUSINESS MANAGEMENT </td><td>PAUL HOANG 5
EDITION</td><td>IBID PRESS</td><td>9781921917820</td></tr>
    <tr><td>11</td><td>BBIOLOGY COURSE COMPANION 2023 EDITION</td><td>ANDREW ALLOTT</td><td>OXFORD</td><td>978-0-19-839211-8</td></tr>
    <tr><td>12</td><td>ENGLISH A: LANGUAGE ANDLITERATURE FOR THE IB DIPLOMA COURSE BOOK</td><td>BRAD PHILPOT</td><td>CUP (2nd Edition)</td><td>978-1108704939</td></tr>
    <tr><td>13</td><td>DOLL HOUSE</td><td>HENRIK IBSEN</td><td></td><td></td></tr>
    <tr><td>14</td><td>RIME OF THE ANCIENT</td><td>S.T. COLERIDGE</td><td></td><td></td></tr>
    <tr><td>15</td><td>THE BOY IN STRIPED PYJAMAS</td><td>JOHN BOYNE</td><td>VINTAGE</td><td>978-0099572862</td></tr>
    <tr><td>16</td><td>1984</td><td>GEORGE ORWELL</td><td>PENGUIN</td><td></td></tr>
    <tr><td>17</td><td>OTHELLO</td><td>WILLIAM SHAKESPEARE</td><td>CUP (3rd Edition)</td><td>978-1107615595</td></tr>
    <tr><td>18</td><td>PERSEPOLIS</td><td>MARJANE SATRAPI</td><td>PANTHEON BOOKS</td><td></td></tr>
    <tr><td>19</td><td>PSYCHOLOGY COURSE COMPANION (2nd Edition)</td><td> </td><td></td><td></td></tr>
    <tr><td>20</td><td>ECONOMICS 2020 EDITION</td><td>JOCELYN BLINK, IAN DORTON</td><td>OXFORD</td><td>978-1-382-00496-1</td></tr>
    <tr><td>21</td><td>ENVIRONMENTAL SYSTEMS AND SOCIETIES (2024 Edition)</td><td>JILL RUTHERFORD, GILLIAN WILLIAMS</td><td>OXFORD (2024 EDITION)</td><td>978-0-19-833256-5</td></tr>
    <tr>
      <td>22</td>
      <td><p>PATVAR PRASANPATRA-1</p><p>PATVAR PRASANPATRA-2</p></td>
      <td>SANDEEP PATIL</td>
      <td>SUVRAN SANDEEP PATIL</td>
      <td><p>978-1-684542628</p><p>978-1-684543052</p></td>
    </tr>
  </tbody>
</table>

             </div> 

            
     
     
      </div>
  
    </div> },
    { title: 'IBDP BOOK LIST 2025-26', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>IBDP Book List 2025-26</h1>
    </div>
    {/* <div className='print-booklist'>

<Link  to="../pdf/Book-list/Ibdp-booklist/IBDP BOOK LIST (2025-26).pdf"
    target="_blank"
    rel="noopener noreferrer"
> Print Book list </Link>
</div> */}
    <div className='syllubus-data'>
      
   

      <div className='cam-lower-table'>
     
     {/* <h1>table data baki ha abhi</h1> */}
    <table border="1">
  <thead>
    <tr>
      <th>S.NO</th>
      <th class="book-width">NAME OF THE BOOK</th>
      <th>AUTHOR</th>
      <th>PUBLISHER</th>
      <th>ISBN NO.</th>
    </tr>
  </thead>
  <tbody>
    <tr><td>1</td><td>FRENCH AB INITIO (TRICOLOR TOTAL 4)</td><td>HEATHER MASCIE TAYLOR</td><td>OUP</td><td>978-140-850578-6</td></tr>
    <tr><td>2</td><td>FRENCH SL/HL FRENCH-B</td><td></td><td>OUP</td><td>978-0-198422-44-9</td></tr>
    <tr><td>3</td><td>PHYSICS FOR IBDP</td><td>K. A TSOKOS</td><td>CAMBRIDGE</td><td>9781009071888</td></tr>
    <tr><td>4</td><td>CHEMISTRY COURSE COMPANION 2023 EDITION</td><td>GARY HORNER, DAVID TARY</td><td>OXFORD</td><td>978-1-382-016469</td></tr>
    <tr><td>5</td><td>CORE COMPUTER SCIENCE</td><td></td><td></td><td></td></tr>
    <tr><td>6</td><td>DIGITAL SOCIETIES</td><td></td><td>HODDER</td><td>9781398358416</td></tr>
    <tr>
      <td>7</td>
      <td>MATHEMATICS: ANALYSIS AND APPROACHES HL (CORE AND MAIN BOOK)</td>
      <td>MICHAEL HAESE</td>
      <td>HAESE AND HARIS</td>
      <td><p><b>CORE:</b> 978-1-925489-58-3</p><p><b>MAIN:</b> 978-1-925489-59-0</p></td>
    </tr>
    <tr><td>8</td><td>MATHEMATICS: ANALYSIS AND APPROACHES SL (CORE TOPICS 1)</td><td>MICHAEL HAESE</td><td>HAESE AND HARIS</td><td>978-1925489-55-2</td></tr>
    <tr><td>9</td><td>MATHEMATICS: APPLICATIONS AND INTERPRETATION SL 2</td><td>MICHAEL HAESE</td><td>HAESE AND HARIS</td><td>978-1-925489-57-6</td></tr>
    <tr>
      <td>10</td>
      <td>MATHEMATICS: APPLICATIONS AND INTERPRETATION HL (CORE AND MAIN BOOK)</td>
      <td>MICHAEL HAESE</td>
      <td>HAESE AND HARIS</td>
      <td><p><b>CORE:</b> 978-1-925489-58-3</p><p><b>MAIN:</b> 978-1925489-60-6</p></td>
    </tr>
    <tr><td>11</td><td>BUSINESS MANAGEMENT (5th Edition)</td><td>PAUL HOANG</td><td>IBID PRESS</td><td>9781921917820</td></tr>
    <tr><td>12</td><td>BIOLOGY COURSE COMPANION 2023 EDITION</td><td>ANDREW ALLOTT</td><td>OXFORD</td><td>978-0-19-839211-8</td></tr>
    <tr><td>13</td><td>ENGLISH A: LANGUAGE AND LITERATURE FOR THE IB DIPLOMA COURSE BOOK</td><td>BRAD PHILPOT</td><td>CUP (2nd Edition)</td><td>978-1108704939</td></tr>
    <tr><td>14</td><td>DOLL HOUSE</td><td>HENRIK IBSEN</td><td></td><td></td></tr>
    <tr><td>15</td><td>RIME OF THE ANCIENT</td><td>S.T. COLERIDGE</td><td></td><td></td></tr>
    <tr><td>16</td><td>THE BOY IN STRIPED PYJAMAS</td><td>JOHN BOYNE</td><td>VINTAGE</td><td>978-0099572862</td></tr>
    <tr><td>17</td><td>1984</td><td>GEORGE ORWELL</td><td>PENGUIN</td><td></td></tr>
    <tr><td>18</td><td>OTHELLO</td><td>WILLIAM SHAKESPEARE</td><td>CUP (3rd Edition)</td><td>978-1107615595</td></tr>
    <tr><td>19</td><td>PERSEPOLIS</td><td>MARJANE SATRAPI</td><td>PANTHEON BOOKS</td><td></td></tr>
    <tr><td>20</td><td>PSYCHOLOGY COURSE COMPANION (2nd Edition)</td><td>ALEXEY POPOV</td><td></td><td></td></tr>
    <tr><td>21</td><td>ECONOMICS 2020 EDITION</td><td>JOCELYN BLINK, IAN DORTON</td><td>OXFORD</td><td>978-1-382-00496-1</td></tr>
    <tr><td>22</td><td>ENVIRONMENTAL SYSTEMS AND SOCIETIES (2024 Edition)</td><td>JILL RUTHERFORD, GILLIAN WILLIAMS</td><td>OXFORD</td><td>978-0-19-833256-5</td></tr>
    <tr>
      <td>23</td>
      <td><p>PATVAR PRASANPATRA-1</p><p>PATVAR PRASANPATRA-2</p></td>
      <td>SANDEEP PATIL</td>
      <td>SUVRAN SANDEEP PATIL</td>
      <td><p>978-1-684542628</p><p>978-1-684543052</p></td>
    </tr>
  </tbody>
</table>

             </div> 

            
     
     
      </div>
  
    </div> },
    { title: 'IBDP BOOK LIST 2024-25', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>IBDP Book List 2024-45</h1>
    </div>
    {/* <div className='print-booklist'>

<Link  to="../pdf/Book-list/Ibdp-booklist/IBDP BOOK LIST 2024- 25.pdf"
    target="_blank"
    rel="noopener noreferrer"
> Print Book list </Link>
</div> */}
    <div className='syllubus-data'>
      
   

      <div className='cam-lower-table'>
     
     {/* <h1>table data baki ha abhi</h1> */}
     
     <table>
       <thead>
         <tr>
          
           <th>S.NO</th>
           <th className='book-width'>NAME OF THE BOOK</th>
           <th>AUTHOR</th>
           <th>PUBLISHER</th>
           <th>ISBN NO.</th>
           
         </tr>
       </thead>
       <tbody>
         <tr>
           <td>1</td>
           <td>FRENCH AB INITIO ( TRICOLOR PART4 )</td>
           <td>HEATHER MASCIE TAYLOR </td>
           <td>OUP</td>
           <td>978-140-850578-6</td>
         </tr>
         <tr>
           <td>2</td>
           <td>FRENCH SL/HL FRENCH-B</td>
           <td></td>
           <td>OUP</td>
           <td>978-0-198422-44-9</td>
         </tr>
         <tr>
           <td>3</td>
           <td>PHYSICS FOR IBDP</td>
           <td>CHRIS HAMPER METCHELL</td>
           <td>PEARSON</td>
           <td><p>SL9781292427713</p><p>HL9781292427706</p></td>
         </tr>
         <tr>
           <td>4</td>
           <td>CHEMISTRY COURSE COMPANION 2023 ED.</td>
           <td>GARY HORNER DAVID TARY</td>
           <td>OXFORD</td>
           <td>978-1-382-016469</td>
         </tr>
         <tr>
           <td>5</td>
           <td>CORE COMPUTER SCIENCE</td>
           <td>KOSTAS DIMITRIOU</td>
           <td>EXPRESS PUB</td>
           <td>978-1-4715-4209</td>
         </tr>
         <tr>
           <td>6</td>
           <td>DIGITAL SOCITIES</td>
           <td></td>
           <td>HODDER</td>
           <td>9781398358416</td>
         </tr>
         <tr>
           <td>7</td>
           <td>MATHEMATICS:ANALYSIS AND APPROACHES HL ( CORE AND MAIN BOOK )</td>
           <td>MICHAEL HAESE </td>
           <td>HAESE AND HARIS</td>
           <td>
            <p><b>CORE-</b>978-1-925489-58-3</p>
            <p><b>MAIN-</b>978-1-925489-59-0</p>
           </td>
         </tr>
         <tr>
           <td>8</td>
           <td>MATHEMATICS:ANALYSIS AND APPROACHES SL(CORE TOPICS 1)</td>
           <td>MICHAEL HAESE </td>
           <td>HAESE AND HARIS</td>
           <td> 978-1925489-55-2</td>
         </tr>
         <tr>
           <td>9</td>
           <td>MATHEMATICS:APPLICATIONS AND INTERPRETATION SL 2</td>
           <td>MICHAEL HAESE </td>
           <td>HAESE AND HARIS </td>
           <td>978-1-925489-57-6</td>
         </tr>
         <tr>
           <td>10</td>
           <td>MATHEMATICS:APPLICATIONS AND INTERPRETATION HL( CORE AND MAIN BOOK )</td>
           <td>MICHAEL HAESE</td>
           <td>HAESE AND HARIS</td>
           <td>
            <p><b>CORE-</b>978-1-925489-58-3</p>           
            <p><b>MAIN-</b>-978-1925489-60-6</p>           
           </td>
         </tr>
         <tr>
           <td>11</td>
           <td>BUSINESS MANAGMENT</td>
           <td>PAUL HOANG 5 EDITION</td>
           <td>IBID PRESS</td>
           <td>9781921917820</td>
         </tr>
         <tr>
           <td>12</td>
           <td>BIOLOGY COURSE COMPANION 2023 EDITION</td>
           <td>ANDREW ALLOTT</td>
           <td>OXFORD</td>
           <td>978-0-19-839211-8</td>
         </tr>
         <tr>
           <td>13</td>
           <td>ENGLISH A:LANGUAGE ANDLITERATURE FOR THE IB DIPLOMA COURSE BOOK </td>
           <td>BRAD PHILPOT</td>
           <td>CUP 2<sup>nd</sup> EDITION</td>
           <td>978-1108704939</td>
         </tr>
         <tr>
           <td>14</td>
           <td>DOLL HOUSE</td>
           <td>HENRIK IBSEN</td>
           <td></td>
           <td></td>
         </tr>
         <tr>
           <td>15</td>
           <td>RIME OF THE ANCIENT</td>
           <td>S.T.COLERIDGE</td>
           <td></td>
           <td></td>
         </tr>
         <tr>
           <td>16</td>
           <td>THE BOY IN STRIPPED PYJAMA </td>
           <td>JOHN BOYNE </td>
           <td>VINTAGE</td>
           <td>978-0099572862</td>
         </tr>
         <tr>
           <td>17</td>
           <td>1984</td>
           <td>GEORGE ORWELL</td>
           <td>PENGUIN</td>
           <td></td>
         </tr>
         <tr>
          <td>18</td>
           <td>OTHELLO</td>
           <td>WILLIAM SHAKESPEARE</td>
           <td>CUP 3<sup>rd</sup>EDITION</td>
           <td>978-1107615595</td>
         </tr>
         <tr>
          <td>19</td>
           <td>PSYCOLOGY COURSE COMPANION 2<sup>nd</sup> EDITION</td>
           <td>ALEXEY POPOV </td>
           <td>OXFORD</td>
           <td>978-0-1983-9811-0</td>
         </tr>
         <tr>
          <td>20</td>
           <td>VISUAL ART COURSE COMPANION</td>
           <td>JAYSON PETERSON</td>
           <td>OXFORD</td>
           <td>978-0-19-837791-7</td>
         </tr>
         <tr>
          <td>21</td>
           <td>ECONOMICS 2020 EDITION</td>
           <td>JOCELYN BLINK IAN DORTON</td>
           <td>OXFORD</td>
           <td>978-1-382-00496-1</td>
         </tr>
         <tr>
          <td>22</td>
           <td>ENVIORMENTAL SYSTEMS AND SOCITIES</td>
           <td>JILL RUTHERFORD GILLIAN WILLIAMS</td>
           <td>OXFORD</td>
           <td>978-0-19-833256-5</td>
         </tr>
         <tr>
          <td>23</td>
           <td>
            <p>PATVAR PRASANPATRA-1</p>
            <p>PATVAR PRASANPATRA-2</p>
           </td>
           <td>SANDEEP PATIL </td>
           <td>SUVRAN SANDEEP PATIL</td>
           <td>
            <p>978-1-684542628</p>
            <p>978-1-684543052

            </p>
            </td>
         </tr>
        </tbody>
             </table>
             </div> 

            
     
     
      </div>
  
    </div> },
//     { title: 'IBDP BOOK LIST 2021-22', content: () => <div>

// <div className='cam-lower-sec'>
//     <h1 className='title'>IBDP Book List 2021-22</h1>
//     </div>
//     <div className='print-booklist'>
//     <Link  to="../pdf/Book-list/Ibdp-booklist/IBDP Book list 2021-22.pdf"
//         target="_blank"
//         rel="noopener noreferrer"
//     > Print Book list </Link>
//     </div>
//     <div className='syllubus-data'>
      
//       <div className='cam-lower-table'>
     
//      {/* <h1>table data baki ha abhi</h1> */}
     
//      <table>
//        <thead>
//          <tr>
          
//            <th>S.NO</th>
//            <th className='book-width'>NAME OF THE BOOK</th>
//            <th>AUTHOR</th>
//            <th>PUBLISHER</th>
//            <th>ISBN NO.</th>
           
//          </tr>
//        </thead>
//        <tbody>
//          <tr>
//            <td>1</td>
//            <td>FRENCH AB INITIO (TRICOLOR PART 4)</td>
//            <td>HEATHER MASCIE TAYLOR</td>
//            <td>OUP</td>
//            <td>978 0 198422 37 2</td>
//          </tr>
//          <tr>
//            <td>2</td>
//            <td>FRENCH SL/HL FRENCH-B </td>
//            <td></td>
//            <td>OUP</td>
//            <td>978-0-198422-41-9</td>
//          </tr>
//          <tr>
//            <td>3</td>
//            <td>PHYSICS FOR IBDP</td>
//            <td>K.A.TSOKOS</td>
//            <td>CUP</td>
//            <td>978-110-7628-19-9</td>
//          </tr>
//          <tr>
//            <td>4</td>
//            <td>CHEMISTRY FOR THE IBDP 2<sup>ND</sup> ED.</td>
//            <td>STEVE OWEN</td>
//            <td>CUP</td>
//            <td>978-1-107-62270-8</td>
//          </tr>
//          <tr>
//            <td>5</td>
//            <td>CORE COMPUTER SCIENCE</td>
//            <td>KOSTAS DIMITRIOU</td>
//            <td>EXPRESS PUB</td>
//            <td>978-1-4715-4209-1</td>
//          </tr>
//          <tr>
//            <td>6</td>
//            <td>ITGS</td>
//            <td>OLIVER KIM</td>
//            <td>IBID PRESS</td>
//            <td>978-1-876659-52-3</td>
//          </tr>
//          <tr>
//            <td>7</td>
//            <td>MATHEMATICS: ANALYSIS AND APPROACHES HL (CORE & MAIN BOOK)</td>
//            <td>MICHAEL HAESE</td>
//            <td>HAESE & HARIS</td>
//            <td>
//             <p><b>CORE-</b>978-1-925489-58-3</p>
//             <p><b>MAIN-</b>978-1-925489-59-0</p>
//            </td>
//          </tr>
//          <tr>
//            <td>8</td>
//            <td>MATHEMATICS: ANALYSIS AND APPROACHES SL (CORE TOPICS 1)</td>
//            <td>MICHAEL HAESE</td>
//            <td>HAESE & HARIS</td>
//            <td>978-1-925489-55-2</td>
//          </tr>
//          <tr>
//            <td>9</td>
//            <td>MATHEMATICS: APPLICATIONS AND INTERPRETATION SL 2</td>
//            <td>MICHAEL HAESE</td>
//            <td>HAESE & HARIS</td>
//            <td>978-1-925489-57-6</td>
//          </tr>
//          <tr>
//            <td>10</td>
//            <td>MATHEMATICS: APPLICATIONS AND INTERPRETATION HL (CORE & MAIN BOOK)</td>
//            <td>MICHAEL HAESE</td>
//            <td>HAESE & HARIS</td>
//            <td>
//             <p><b>CORE-</b>978-1-925489-58-3</p>           
//             <p><b>MAIN-</b>978-1-925489-60-6</p>           
//            </td>
//          </tr>
//          <tr>
//            <td>11</td>
//            <td>BUSINESS MANAGEMENT</td>
//            <td>PAUL HOANG</td>
//            <td>IBID PRESS</td>
//            <td>978-1-9219172-4-0</td>
//          </tr>
//          <tr>
//            <td>12</td>
//            <td>BIOLOGY COURSE COMPANION 2014 ED.</td>
//            <td>ANDREW ALLOTT</td>
//            <td>OXFORD</td>
//            <td>978-0-19-839211-8</td>
//          </tr>
//          <tr>
//            <td>13</td>
//            <td>ENGLISH A: LANG & LIT</td>
//            <td>ROB ALLISON</td>
//            <td>OXFORD</td>
//            <td>978-0-1984-3452-8</td>
//          </tr>
//          <tr>
//            <td>14</td>
//            <td>A DOLL’S HOUSE</td>
//            <td>HENRIK IBSEN</td>
//            <td>DOVER </td>
//            <td>978-0-486-27062-3</td>
//          </tr>
//          <tr>
//            <td>15</td>
//            <td>THE WORLD’S WIFE</td>
//            <td>CAROLANE DUFFY</td>
//            <td>PAN MAC</td>
//            <td>978-15-0-985266-6</td>
//          </tr>
//          <tr>
//            <td>16</td>
//            <td>THE COMPLETE PERSEPOLIS</td>
//            <td>MARJANE SATRAPI</td>
//            <td>VINTAGE</td>
//            <td>978-0-099-52399-4</td>
//          </tr>
//          <tr>
//            <td>17</td>
//            <td>THE MERCHANT OF VENICE</td>
//            <td>XAVIER PINTO</td>
//            <td>BEETA PUB</td>
//            <td>555-1234-00-590-1</td>
//          </tr>
//          <tr>
//           <td>18</td>
//            <td>SELECTED POEMS</td>
//            <td>ANNA AKHMATOVA</td>
//            <td>VINTAGE</td>
//            <td>9978-0-099540-87-8</td>
//          </tr>
//          <tr>
//           <td>19</td>
//            <td>PSYCHOLOGY COURSE COMPANION 2<sup>ND</sup> ED.</td>
//            <td>ALEXEY POPOV</td>
//            <td>OXFORD</td>
//            <td>978-0-1983-9811-0</td>
//          </tr>
//          <tr>
//           <td>20</td>
//            <td>VISUAL ART COURSE COMPANION</td>
//            <td>JAYSON PETERSON</td>
//            <td>OXFORD</td>
//            <td>978-0-19-837791-7</td>
//          </tr>
//          <tr>
//           <td>21</td>
//            <td>ECONOMICS FOR THE IBDP</td>
//            <td>PAUL HOANG</td>
//            <td>HODDER EDUCATION</td>
//            <td>978-1-5104-7914-2</td>
//          </tr>
//          <tr>
//           <td>22</td>
//            <td>ENVIRONMENTAL SYSTEMS AND SOCIETIES</td>
//            <td>JILL RUTHERFORD GILLIAN WILLIAMS</td>
//            <td>OXFORD</td>
//            <td>978-0-19-84233 6 2</td>
//          </tr>
//          <tr>
//           <td>23</td>
//            <td>
//             <p>PATVAR PRASANPATRA-1</p>
//             <p>PATVAR PRASANPATRA-2</p>
//            </td>
//            <td>SANDEEP PATIL </td>
//            <td>SUVRAN SANDEEP PATIL</td>
//            <td>
//             <p>978-1-684542628</p>
//             <p>978-1-684543052</p>
//             </td>
//          </tr>
//         </tbody>
//              </table>

//              <br></br>
//              <p>** CALCULATOR-GDC (CASIO SCIENTIFIC GRAPHIC CALCULATOR FX CG50)</p>
//              </div> 

//              <div className='syllubs-list'>
//       <Link to="">Print Book List</Link>
//       </div>
//     </div>

//     </div> },
//     { title: 'IBDP BOOK LIST 2020-21', content: () => <div>

// <div className='cam-lower-sec'>
//     <h1 className='title'>Annual Syllabus 2020-21</h1>
//     </div>
//     <div className='print-booklist'>
//       <Link  to="../pdf/Book-list/Ibdp-booklist/IBDP BOOK LIST  2020-21.pdf"
//         target="_blank"
//         rel="noopener noreferrer"
//     > Print Book list </Link>
//     </div>
//     <div className='syllubus-data'>
      
//       <div className='cam-lower-table'>
     
//      {/* <h1>table data baki ha abhi</h1> */}
     
//      <table>
//        <thead>
//          <tr>
          
//            <th>S.NO</th>
//            <th className='book-width'>NAME OF THE BOOK</th>
//            <th>AUTHOR</th>
//            <th>PUBLISHER</th>
//            <th>ISBN NO.</th>
           
//          </tr>
//        </thead>
//        <tbody>
//          <tr>
//            <td>1</td>
//            <td>FRENCH AB INITIO (TRICOLOR PART 4) </td>
//            <td>HEATHER MASCIE TAYLOR</td>
//            <td>OUP</td>
//            <td>978-140-850578-6</td>
//          </tr>
//          <tr>
//            <td>2</td>
//            <td> FRENCH SL/HL FRENCH-B</td>
//            <td></td>
//            <td> OUP</td>
//            <td>978-0-198422-41-9</td>
//          </tr>
//          <tr>
//            <td>3</td>
//            <td>PHYSICS FOR IBDP</td>
//            <td>K.A.TSOKOS</td>
//            <td>CUP</td>
//            <td>978-110-7628-19-9</td>
//          </tr>
//          <tr>
//            <td>4</td>
//            <td>CHEMISTRY FOR THE IBDP 2<sup>ND</sup> ED.</td>
//            <td>STEVE OWEN</td>
//            <td>CUP</td>
//            <td>978-1-107-62270-8</td>
//          </tr>
//          <tr>
//            <td>5</td>
//            <td>CORE COMPUTER SCIENCE</td>
//            <td>KOSTAS DIMITRIOU</td>
//            <td>EXPRESS PUB</td>
//            <td>978-1-4715-4209-1</td>
//          </tr>
//          <tr>
//            <td>6</td>
//            <td>MATHEMATICS: ANALYSIS AND APPROACHES HL</td>
//            <td>MARIENE TORRES SKOUMAL</td>
//            <td>OXFORD</td>
//            <td>978-0-198427-16-2</td>
//          </tr>
//          <tr>
//            <td>7</td>
//            <td>MATHEMATICS: ANALYSIS AND APPROACHES SL </td>
//            <td>PAUL LA RONDIE</td>
//            <td>OXFORD </td>
//            <td>
//             <p>978-0-198427-10-0</p>
//            </td>
//          </tr>
//          <tr>
//            <td>8</td>
//            <td>MATHEMATICS: APPLICATIONS AND  INTERPRETATION SL</td>
//            <td>JANE FORREST</td>
//            <td>OXFORD</td>
//            <td>978-0-198426-98-1</td>
//          </tr>
//          <tr>
//            <td>9</td>
//            <td>MATHEMATICS: APPLICATIONS AND INTERPRETATION HL</td>
//            <td>TONY HALSEY</td>
//            <td>OXFORD </td>
//            <td>978-0-198427-04-9</td>
//          </tr>
//          <tr>
//            <td>10</td>
//            <td>BUSINESS MANAGEMENT</td>
//            <td>PAUL HOANG</td>
//            <td>IBID PRESS</td>
//            <td>
//             <p>978-1-9219172-4-0</p>           
//             <p><b>MAIN-</b>978-1-925489-60-6</p>
//           </td>
//          </tr>
//          <tr>
//            <td>11</td>
//            <td>BIOLOGY COURSE COMPANION 2014 ED.</td>
//            <td>ANDREW ALLOTT</td>
//            <td>OXFORD</td>
//            <td>978-0-19-839211-8</td>
//          </tr>
//          <tr>
//            <td>12</td>
//            <td>ENGLISH A: LANG & LIT.</td>
//            <td>ROB ALLISON</td>
//            <td>OXFORD</td>
//            <td>978-0-1984-3452-8</td>
//          </tr>
//          <tr>
//            <td>13</td>
//            <td> A DOLL’S HOUSE </td>
//            <td>HENRIK IBSEN</td>
//            <td>DOVER</td>
//            <td>978-0-486-27062-3</td>
//          </tr>
//          <tr>
//            <td>14</td>
//            <td>THE WORLD’S WIFE </td>
//            <td>CAROLANE DUFFY</td>
//            <td>PAN MAC </td>
//            <td>978-15-0-985266-6</td>
//          </tr>
//          <tr>
//            <td>15</td>
//            <td>THE COMPLETE PERSEPOLIS</td>
//            <td>MARJANE SATRAPI</td>
//            <td>VINTAGE</td>
//            <td>978-0-099-52399-4</td>
//          </tr>
//          <tr>
//            <td>16</td>
//            <td>THE MERCHANT OF VENICE</td>
//            <td>XAVIER PINTO</td>
//            <td>BEETA PUB</td>
//            <td>555-1234-00-590-1</td>
//          </tr>
//          <tr>
//            <td>17</td>
//            <td>SELECTED POEMS</td>
//            <td>ANNA AKHMATOVA</td>
//            <td>VINTAGE</td>
//            <td>978-0-099540-87-8</td>
//          </tr>
//          <tr>
//           <td>18</td>
//            <td>PSYCHOLOGY COURSE COMPANION 2ND ED.</td>
//            <td>ALEXEY POPOV</td>
//            <td>OXFORD</td>
//            <td>978-0-1983-9811-0</td>
//          </tr>
//          <tr>
//           <td>19</td>
//            <td>VISUAL ART COURSE COMPANION</td>
//            <td>JAYSON PETERSON  </td>
//            <td>OXFORD</td>
//            <td>978-0-19-837791-7</td>
//          </tr>
//          <tr>
//           <td>20</td>
//            <td>ECONOMICS FOR THE IBDP</td>
//            <td>PAUL HOANG </td>
//            <td>HODDER PUBLICATION</td>
//            <td>978-1-51-047914-2</td>
//          </tr>
//          <tr>
//           <td>21</td>
//            <td>TOK</td>
//            <td>MARIJA UZUNOVA DANG ARVIN SINGH UZNOV DANG</td>
//            <td>OXFORD</td>
//            <td>978-0-19-849770-7</td>
//          </tr>
//         </tbody>
//              </table>
//             <br></br>
//              <p>** CALCULATOR –GDC (CASIO SCIENTIFIC GRAPHIC CALCULATOR FXCG50)</p>
//              </div> 

//              <div className='syllubs-list'>
//       <Link to="">Print Book List</Link>
//       </div>
//     </div>

//     </div> },



  
  ];
  return (
    <div>
      <div className='ibdp-hero-sec'>
        <img src='newimg/booklist.webp'/>

      </div>
   
      <div className='ib-syllabus  '>
        {/* <Igcsedata/> */}
        <HorizontalTabs tabs={tabs} />
      </div>
    </div>
  )
}

export default bookList
